import { render, staticRenderFns } from "./section-suggestion.vue?vue&type=template&id=a65ba2ca&scoped=true"
import script from "./section-suggestion.vue?vue&type=script&lang=js"
export * from "./section-suggestion.vue?vue&type=script&lang=js"
import style0 from "./section-suggestion.vue?vue&type=style&index=0&id=a65ba2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ba2ca",
  null
  
)

export default component.exports